import { Feature, InjectorService } from '@tencent/workbench';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { EffectPropsField } from '@editor/src/js/constants';
import { INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IReflectionShower } from '@tencent/drawing-drawer-components';
import { ReflectionFeature } from '@framework/workbench/drawer/ui/effects/reflection/reflection-feature';

@Feature()
export class ReflectionShower extends BaseDrawerEffectFeature implements IReflectionShower {
    private reflectionFeature: ReflectionFeature;
    public constructor() {
        super();
        this.reflectionFeature = InjectorService.get(ReflectionFeature);
    }

    public getReflectionSize() {
        return this.getShownValue(INPUT_PROPS_CALLBACK_KEY.REFLECTION, { size: this.reflectionFeature.size });
    }

    public getReflectionBlur() {
        return this.getShownValue(INPUT_PROPS_CALLBACK_KEY.REFLECTION, { blurRad: this.reflectionFeature.blur });
    }

    public getReflectionDistance() {
        return this.getShownValue(INPUT_PROPS_CALLBACK_KEY.REFLECTION, { dist: this.reflectionFeature.dist });
    }

    public getReflectionOpacity() {
        return this.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.REFLECTION,
            { [EffectPropsField.STARTOPACITY.name]: this.reflectionFeature.opacity },
        );
    }
}
